export default "__VITE_ASSET__c4621061__"